export const EVENT_NAME = {
  CTA_CLICK: "CTA Clicked"
};
